module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    staticClass: "compass",
    style: (_vm.angle),
    attrs: {
      "src": require("@/assets/images/compass.svg"),
      "width": "88px"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4147ca06","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/controller/building_compass.vue
// module id = 832
// module chunks = 0